<template>
    <LayoutLogin>

        <div class="pb-13 pt-lg-0 pt-5">
            <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
                <template v-if="submitForm">パスワード再設定完了</template>
                <template v-else >パスワード再設定</template>
            </h3>
        </div>

        <div v-if="submitForm" class="">
            <h5 class="text-left">パスワード再設定が完了しました。</h5>
            <div class="d-flex justify-content-center mt-20">
                <el-button class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3" type="primary"
                    @click="$router.push('login')">ログインへ</el-button>
            </div>
        </div>

        <div v-else>
            <el-form :model="form" status-icon :rules="rules" ref="form" label-position="top" >

                <div class="form-group">
                    <label class="font-size-h6 font-weight-bolder text-dark">新規のパスワード</label>
                    <el-form-item prop="password">
                        <el-input type="password" class="input-email" v-model.lazy="form.password" />
                    </el-form-item>
                </div>

                <div class="form-group">
                    <label class="font-size-h6 font-weight-bolder text-dark">パスワード再入力</label>
                    <el-form-item prop="password_confirmation">
                        <el-input type="password" class="input-email" v-model.lazy="form.password_confirmation" />
                    </el-form-item>
                </div>

                <div class="d-flex justify-content-center mt-0">
                    <el-button class="btn-custom" type="" @click="$router.push('login')">
                        キャンセル
                    </el-button>
                    <el-button class="btn-custom" type="primary" @click="onSubmit">
                        確定
                    </el-button>
                </div>
                <input type="hidden" name="_csrf" v-model="form._csrf" />
            </el-form>
        </div>
    </LayoutLogin>
</template>

<script>
import { mapMutations } from "vuex";
import apiService from "@/core/services/api.service";
import { CALL_CSRF_TOKEN, getSCRFToken, getCsrfRandom } from "@/core/services/store/auth.module";
import { SET_LOADING, NOT_LOADING } from "@/core/services/store/htmlclass.module";

import LayoutLogin from "@/view/pages/auth/Layout"

export default {
    name: "ResetPassword",
    components: {
        LayoutLogin
    },
    data() {
        return {
            form: {
                code: '',
                password: '',
                password_confirmation: '',
                _csrf: ''
            },
            popup: false,
            contentPoopup: '',
            rules: {},
            submitForm: false
        }
    },
    computed: {
        queryParam() {
            return this.$route.query
        },
        backgroundImage() {
            return (
                process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
            );
        }
    },
    created() {
        this.getDataFromQuery();
        this.form._csrf = getCsrfRandom();
        if (!getSCRFToken()) {
            this.$store.dispatch(CALL_CSRF_TOKEN);
        }
    },
    mounted() {
        const vm = this
        window.addEventListener('keyup', function (event) {
            if (event.keyCode === 13) {
                vm.onSubmit()
            }
        });
    },
    methods: {
        ...mapMutations([SET_LOADING, NOT_LOADING]),
        getDataFromQuery() {
            this.form.token = this.queryParam.token ? this.queryParam.token : '';
        },
        onSubmit() {
            this[SET_LOADING]()
            this.$refs["form"].clearValidate()
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.turnOffErrorMessage('form')
                    let data = JSON.parse(JSON.stringify(this.form))
                    apiService.post(`user/auth/reset-password`, data).then(res => {
                        if (res && res.data && res.data.success) {
                            this.submitForm = true
                        } else if (res.data.code = 422) {
                            if (res.data && res.data.data && res.data.data.token && res.data.data.token[0]) {
                                this.popup = true
                                this.contentPoopup = res.data.data.token[0]
                            } else {
                                this.showErrorMessage(res.data.data, 'form')
                            }
                        } else {
                            this.notifyError('error server')
                        }
                        this[NOT_LOADING]()
                    }).catch(e => {
                        this[NOT_LOADING]()
                        this.notifyError(e)
                    })
                }
            })
        }
    }
}
</script>